import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40050eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coaching-session-view rounded-3 my-3 px-4 pt-3" }
const _hoisted_2 = { class: "coaching-session-view__header" }
const _hoisted_3 = { class: "coaching-session-view__title" }
const _hoisted_4 = ["aria-label", "title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border border-secondary" }, null, -1))
const _hoisted_6 = { class: "coaching-session-view__detail row" }
const _hoisted_7 = { class: "col-4 my-auto" }
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = ["aria-label", "title"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-decoration-none" }, " Your Coach:  ", -1))
const _hoisted_12 = { class: "text-decoration-underline" }
const _hoisted_13 = { class: "col-5 my-auto d-flex align-items-center" }
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "coaching-session-view__next-session col-3 d-flex justify-content-end" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border border-secondary" }, null, -1))

import { computed, onMounted, ref } from 'vue'
import { CoachingSessionViewModel } from './CoachingSessionView.interfaces'
import locales from './CoachingSessionView.locales.en.json'
import CalendarIcon from '@/icons/CalendarIcon.vue'
import BarButton from '@/components/BarButton'
import CirclePersonIcon from '@/icons/CirclePersonIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionView',
  props: {
    modelValue: {},
    showScheduleNotification: { type: Boolean }
  },
  emits: ["show-cancel-session", "show-about-coach", "show-schedule-detail"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit =
  __emit

function handleCancelSessionClick() {
  emit('show-cancel-session')
}

function handleAboutCoachClick() {
  emit('show-about-coach')
}

function onScheduleDetailClick(){
  emit('show-schedule-detail')
}

const hasScheduleChanges = computed(()=> props.showScheduleNotification ?? false)

const profilePictureSource = ref('')

onMounted(() => {
  if (props.modelValue.coach.profilePicture) {
    profilePictureSource.value = window.URL.createObjectURL(props.modelValue.coach.profilePicture)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(locales).title_coaching_session), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "button-link text-decoration-underline",
          "aria-label": _unref(locales).button_cancel_session,
          title: _unref(locales).button_cancel_session,
          onClick: handleCancelSessionClick
        }, _toDisplayString(_unref(locales).link_cancel), 9, _hoisted_4)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(locales).label_coach_name) + ": " + _toDisplayString(_ctx.modelValue.coach.displayName), 1),
        _createElementVNode("button", {
          class: "button-link text-ellipsis d-flex align-items-center",
          "aria-label": _unref(locales).button_coach_name_details,
          title: 
            _unref(locales).button_coach_name_details +
              ' ' +
              _ctx.modelValue.coach.displayName
          ,
          onClick: handleAboutCoachClick
        }, [
          (profilePictureSource.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "rounded-circle profile-image me-2",
                src: profilePictureSource.value
              }, null, 8, _hoisted_10))
            : (_openBlock(), _createBlock(CirclePersonIcon, {
                key: 1,
                width: "36",
                height: "36",
                class: "me-2"
              })),
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.modelValue.coach.displayName), 1)
        ], 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(locales).label_session_schedule) + ": ", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.modelValue.session.displaySchedule) + " ", 1),
        (_ctx.modelValue.expired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(_unref(locales).message_session_has_expired) + ") ", 1))
          : _createCommentVNode("", true),
        (hasScheduleChanges.value && !_ctx.modelValue.expired)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "border-0 bg-white",
              "aria-label": "view session schedule",
              onClick: onScheduleDetailClick
            }, [
              _createVNode(CalendarIcon, { "aria-hidden": "true" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.modelValue.nextSession)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("a", {
                class: "link text-decoration-none",
                href: _ctx.modelValue.nextSession.url,
                target: "_blank"
              }, [
                _createVNode(_unref(BarButton), {
                  class: "mx-0 py-3 px-4 fs-6 d-flex align-items-center",
                  mode: "outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(locales).join_session), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_18)
            ]))
          : (!_ctx.modelValue.expired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("small", null, _toDisplayString(_unref(locales).message_session_available_in_24_hours_pt_1), 1),
                _hoisted_20,
                _createElementVNode("small", null, _toDisplayString(_unref(locales).message_session_available_in_24_hours_pt_2), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_21
  ]))
}
}

})